export default (theme) => ({
  root: {
    ...theme.flexColumnCenter,
    justifyContent: 'center',
    width: '100%',
    height: '100%'
  },
  fields: {
    width: '100%',
    marginBottom: '2rem'
  }
})
